import React from "react"
import styled from "styled-components"
import { useTranslation } from "src/i18next"
import { CheckBoxPanel } from "src/components/checkboxPanel"
import { ShowOnFeatureSwitch } from "src/providers/featureSwitchProvider"

const FieldSet = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
`

const Legend = styled.legend`
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: ${({ theme }) => theme.spacing.baseSpacing};
`

export const CommunicationPreferences: React.FC = () => {
  const { t } = useTranslation("communicationDetails")

  return (
    <FieldSet>
      <Legend>{t("communicationPreferences")}</Legend>
      <CheckBoxPanel
        label={t("emailMarketing")}
        name="receiveEmailNewsletter"
      />

      <CheckBoxPanel label={t("smsMarketing")} name="receiveMarketingSms" />

      <CheckBoxPanel
        label={t("socialMediaMarketing")}
        name="receiveMarketingSocialMedia"
      />

      <ShowOnFeatureSwitch featureSwitch={"displayMarketingSurveysOption"}>
        <CheckBoxPanel
          label={t("surveyMarketing")}
          name="receiveMarketingSurveys"
        />
      </ShowOnFeatureSwitch>
    </FieldSet>
  )
}
